import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AssetLocationsUpdated, AssetUpdated, eventBus, PmStore } from "@/state";


const mutationSetAssetActiveFlag = gql`
  mutation setAssetActiveFlag($organizationId: UUID!,$assetId: UUID!, $active: Boolean!) {
    setAssetActiveFlag(organizationId: $organizationId, assetId: $assetId, active: $active) 
  }  
`;


const mutationSetAssetAddressId = gql`
  mutation setAssetAddress($organizationId: UUID!,$assetId: UUID!, $addressId: UUID!) {
    setAssetAddress(organizationId: $organizationId, assetId: $assetId, addressId: $addressId) 
  }  
`;

const mutationAddAssetType = gql`
  mutation addAssetType($organizationId: UUID!, $name: String!, $description: String!) {
    addAssetType(
      organizationId: $organizationId
      name: $name
      description: $description
    ){
       id
    }
  }
`;

const mutationRemoveAssetContractTemplate = gql`
  mutation removeAssetContractTemplate($organizationId: UUID!, $assetId: UUID!, $templateId: UUID!) {
    removeAssetContractTemplate(organizationId: $organizationId, assetId: $assetId, templateId: $templateId) 
  }
`;



const queryAssetSearch = gql`
  query assetSearch(
    $organizationId: UUID!
    $term: String!
    $page: Int!
    $assetTypeId: UUID
    $showOnlyActive: Boolean
    $locations: [UUID!]
  ) {
    assetSearch(
	 organizationId: $organizationId
	 term: $term
	 page: $page
	 assetTypeId: $assetTypeId
	 locations: $locations
	 showOnlyActive: $showOnlyActive
    ) {
	 totalCount
	 pageInfo {
	   hasNextPage
	   hasPreviousPage
	 }
	 items {
	   id
	   active
	   address_full
	   asset_active
	   asset_available_for_leasing
	   asset_has_deposit_defined
	   asset_has_rent_defined
	   asset_has_reservations_available_defined
	   asset_description
	   asset_name
	   asset_type
	   asset_type_id
	 }
    }
  }
`;




const queryGetAsset = gql`
  query GetAsset($organizationId: UUID!, $assetId: UUID!) {
    asset(organizationId: $organizationId, assetId: $assetId) {
      id
      name
      code
      address_id
      address
      active
      layout_id
      layout {
        id
        name
      }
      location_id
      location_name
      description
      available_for_leasing
      is_published
      isAvailable
      type_id
      type {
        name
        enable_deposit
        enable_rent
        enable_one_time_payment
      }
      image_id
      image { 
       url
       name
      }
      owning_legal_entity_id
      owning_legal_entity {
        id
        name
        
      }
      sales_tax_id
     }
  }
`;




const queryGetLayouts = gql`
  query layouts($organizationId: UUID!) {
    layouts(organizationId: $organizationId) {
        id
        name
        description
        type_id
        updated_ts

    }
  }
`;


const mutationSetAssetDescription = gql`
  mutation setAssetDescription($organizationId: UUID!,$assetId: UUID!, $description: String!) {
    setAssetDescription(organizationId: $organizationId, assetId: $assetId, description: $description) 
  }  
`;


const mutationSetAssetLocationId = gql`
  mutation setAssetLocation($organizationId: UUID!,$assetId: UUID!, $locationId: UUID!) {
    setAssetLocation(organizationId: $organizationId, assetId: $assetId, locationId: $locationId) 
  }  
`;

const mutationSetAssetName = gql`
  mutation setAssetName($organizationId: UUID!,$assetId: UUID!, $name: String!) {
    setAssetName(organizationId: $organizationId, assetId: $assetId, name: $name) 
  }  
`;



const mutationSetAssetTypeDescription = gql`
  mutation setAssetTypeRequireVehicle($organizationId: UUID!, $assetTypeId: UUID!, $description: String!) {
    setAssetTypeDescription(organizationId: $organizationId, id: $assetTypeId, description: $description)
  }
`;

const mutationSetAssetTypeRequireVehicle = gql`
  mutation setAssetTypeRequireVehicle( $organizationId: UUID! $assetTypeId: UUID!  $enabled: Boolean! ) {
    setAssetTypeRequireVehicle( organizationId: $organizationId  id: $assetTypeId enabled: $enabled )
  }
`;


const mutationSetAssetTypeRegenerateContractsOnMove = gql`
  mutation setAssetTypeRegenerateContractsOnMove($organizationId: UUID! $assetTypeId: UUID! $enabled: Boolean!) {
    setAssetTypeRegenerateContractsOnMove(organizationId: $organizationId id: $assetTypeId enabled: $enabled )
  }
`;

const mutationSetAssetTypeRent = gql`
  mutation setAssetTypeRent($organizationId: UUID! $assetTypeId: UUID! $enabled: Boolean!) {
    setAssetTypeRent(organizationId: $organizationId id: $assetTypeId enabled: $enabled)
  }
`;


const mutationSetAssetTypeDeposit = gql`
  mutation setAssetTypeDeposit($organizationId: UUID! $assetTypeId: UUID! $enabled: Boolean!) {
    setAssetTypeDeposit(organizationId: $organizationId id: $assetTypeId enabled: $enabled)
  }
`;

const mutationSetAssetTypeOneTimePayment = gql`
  mutation setAssetTypeOneTimePayment($organizationId: UUID! $assetTypeId: UUID! $enabled: Boolean!) {
    setAssetTypeOneTimePayment(organizationId: $organizationId id: $assetTypeId enabled: $enabled)
  }
`;


const mutationSetAssetTypePublished = gql`
  mutation setAssetTypePublished($organizationId: UUID! $assetTypeId: UUID! $enabled: Boolean!) {
    setAssetTypePublished(organizationId: $organizationId id: $assetTypeId enabled: $enabled)
  }
`;


const mutationSetAssetTypeAvailableForLeasing = gql`
  mutation setAssetTypeAvailableForLeasing($organizationId: UUID! $assetTypeId: UUID! $enabled: Boolean!) {
    setAssetTypeAvailableForLeasing(organizationId: $organizationId id: $assetTypeId enabled: $enabled)
  }
`;



const queryGetAssetType = gql`
  query GetAssetType($organizationId: UUID!, $assetTypeId: UUID!) {
    assetType(organizationId: $organizationId, id: $assetTypeId) {
      id
      name
      available_for_leasing
      description
      enable_deposit
      enable_one_time_payment
      enable_rent
      published
      regenerate_contracts_on_move
      require_vehicle
    }
  }
`;



const mutationSetAssetDetail = gql`
 mutation setAssetDetail($organizationId: UUID!, $assetId: UUID!, $attributeId: UUID!, $idValue: UUID, $boolValue: Boolean, $textValue: String) {
    setAssetDetail(organizationId: $organizationId, assetId: $assetId, attributeId: $attributeId, idValue: $idValue, boolValue: $boolValue, textValue: $textValue) 
    {
        asset_id
        attribute_id
        value_text
        value_id
        value_bool
    }
 }    
`;


const mutationAddAssetContractTemplate = gql`
  mutation addAssetContractTemplate($organizationId: UUID!, $assetId: UUID!, $templateId: UUID!) {
    addAssetContractTemplate(organizationId: $organizationId, assetId: $assetId, templateId: $templateId) 
  }
`;


const queryAssetContractTemplates = gql`
  query GetAssetContractTemplates($organizationId: UUID!, $assetId: UUID!) {
    assetContractTemplates(organizationId: $organizationId, assetId: $assetId) {
     template_id
      template {
        id
        name
        type
        updated_ts
      }
    }
  }
`;


const mutationCreateAsset = gql`
  mutation create($organizationId: UUID!, $typeId:  UUID!, $name: String!, $legalEntityId: UUID, $locationId: UUID, $code: String!) {
    createAsset(organizationId: $organizationId, typeId: $typeId, name: $name, legalEntityId: $legalEntityId, locationId: $locationId, code: $code) {
      id
    }
  }  
`;


const mutationAddLocation = gql`
  mutation addLocation($organizationId: UUID!, $name: String!, $code: String!, $description: String!) {
    addLocation(organizationId: $organizationId,  name: $name, code: $code, description: $description) {
      id
    }
  }  
`;


const gqlRemoveAssetAttribute = gql`
  mutation removeAttribute($organizationId: UUID!, $attributeId: UUID!) {
    removeAttribute(organizationId: $organizationId, attributeId: $attributeId)
  }
`;


const gqlRenameAssetAttribute = gql`
  mutation changeAttributeName($organizationId: UUID!, $attributeId: UUID!, $name: String!) {
    changeAttributeName(organizationId: $organizationId, attributeId: $attributeId, name: $name) 
  }
`;




export function useAssetActions() {
  const state = PmStore();
  const [apiSetAssetActiveFlag] = useMutation(mutationSetAssetActiveFlag);
  const [apiSetAssetAddressId] = useMutation(mutationSetAssetAddressId);
  const [apiAddAssetType] = useMutation(mutationAddAssetType);
  const [apiRemoveAssetContractTemplate] = useMutation(mutationRemoveAssetContractTemplate);
  const [apiAssetSearch] = useLazyQuery(queryAssetSearch);
  const [apiGetAsset] = useLazyQuery(queryGetAsset);
  const [apiGetLayouts] = useLazyQuery(queryGetLayouts);
  const [apiSetAssetDescription] = useMutation(mutationSetAssetDescription);
  const [apiSetAssetLocationId] = useMutation(mutationSetAssetLocationId);
  const [apiSetAssetName] = useMutation(mutationSetAssetName);
  const [apiSetAssetTypeDescription] = useMutation(mutationSetAssetTypeDescription);
  const [apiSetAssetTypeRequireVehicle] = useMutation(mutationSetAssetTypeRequireVehicle);
  const [apiSetAssetTypeRegenerateContractsOnMove] = useMutation(mutationSetAssetTypeRegenerateContractsOnMove);
  const [apiSetAssetTypeRent] = useMutation(mutationSetAssetTypeRent);
  const [apiSetAssetTypeDeposit] = useMutation(mutationSetAssetTypeDeposit);
  const [apiSetAssetTypeOneTimePayment] = useMutation(mutationSetAssetTypeOneTimePayment);
  const [apiSetAssetTypePublished] = useMutation(mutationSetAssetTypePublished);
  const [apiSetAssetTypeAvailableForLeasing] = useMutation(mutationSetAssetTypeAvailableForLeasing);
  const [apiGetAssetType] = useLazyQuery(queryGetAssetType);
  const [apiSetAssetDetail] = useMutation(mutationSetAssetDetail);
  const [apiAddAssetContractTemplate] = useMutation(mutationAddAssetContractTemplate);
  const [apiAssetContractTemplates] = useLazyQuery(queryAssetContractTemplates);

  const [apiCreateAsset] = useMutation(mutationCreateAsset);
  const [apiAddLocation] = useMutation(mutationAddLocation);

  
  async function AddLocation(name: string, code: string, description: string): Promise<any> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiAddLocation({ variables: { organizationId, description, name, code } }) as any;
      eventBus.next({type: AssetLocationsUpdated})
      return result.data.addLocation as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to create new asset.");
    }
  }



  async function CreateAsset(typeId: string, name: string, legalEntityId: string, locationId: string, code: string): Promise<any> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiCreateAsset({ variables: { organizationId, typeId, name, legalEntityId, locationId, code } }) as any;
      eventBus.next({type: AssetUpdated})
      return result.data.createAsset as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to create new asset.");
    }
  }

  async function GetAssetContractTemplates(assetId: string): Promise<any> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiAssetContractTemplates({ variables: { organizationId, assetId } }) as any;
      return result.data.assetContractTemplates as [];
    }
    catch (err) {
      toast.error("Api Error, Unable to get asset contract templates");
    }
  }



  async function AddAssetContractTemplate(assetId: string, templateId: string): Promise<any> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiAddAssetContractTemplate({ variables: { organizationId, assetId, templateId } }) as any;
      return result.data.addAssetContractTemplate as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to add asset contract template");
    }
  }

  

  
  async function SetAssetDetail(assetId: string, attributeId: string, idValue: string, boolValue: string, textValue: string): Promise<any> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetDetail({ variables: { organizationId, assetId, attributeId, idValue, boolValue, textValue } }) as any;
      return result.data.setAssetDetail as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset details");
    }
  }


  async function GetAssetType(assetTypeId: string): Promise<any> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetAssetType({ variables: { organizationId, assetTypeId } }) as any;
      return result.data.assetType as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to get asset type");
    }
  }



  async function SetAssetTypeAvailableForLeasing(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeAvailableForLeasing({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypeAvailableForLeasing as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type available flag");
    }
  }



  async function SetAssetTypePublished(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypePublished({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypePublished as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type published flag");
    }
  }

  
  

  async function SetAssetTypeOneTimePayment(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeOneTimePayment({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypeOneTimePayment as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type one time deposit");
    }
  }

  
  async function SetAssetTypeDeposit(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeDeposit({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypeDeposit as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type deposit");
    }
  }

  async function SetAssetTypeRent(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeRent({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypeRent as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type rent");
    }
  }


  async function SetAssetTypeRegenerateContractsOnMove(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeRegenerateContractsOnMove({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypeRegenerateContractsOnMove as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type contract regeneration flag");
    }
  }
  
  
  async function SetAssetTypeRequireVehicle(assetTypeId: string, enabled: boolean): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeRequireVehicle({ variables: { organizationId, assetTypeId, enabled } }) as any;
      return result.data.setAssetTypeRequireVehicle as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type required vehicle flag");
    }
  }

  async function SetAssetTypeDescription(assetTypeId: string, description: string): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetTypeDescription({ variables: { organizationId, assetTypeId, description } }) as any;
      return result.data.setAssetTypeDescription as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset type description");
    }
  }


  async function SetAssetName(assetId: string, name: string): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetName({ variables: { organizationId, assetId, name } }) as any;
      return result.data.setAssetName as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to get layouts");
    }
  }



  async function SetAssetLocationId(assetId: string, locationId: string): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetLocationId({ variables: { organizationId, assetId, locationId } }) as any;
      return result.data.setAssetLocation as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to get layouts");
    }
  }


  async function SetAssetDescription(assetId: string, description: string): Promise<boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetDescription({ variables: { organizationId, assetId, description } }) as any;
      return result.data.setAssetDescription as boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to get layouts");
    }
  }



  async function GetLayouts() {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetLayouts({ variables: { organizationId } }) as any;
      return result.data.layouts as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to get layouts");
    }
  }
  
  

  async function GetAsset(assetId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetAsset({ variables: { organizationId,assetId } }) as any;
      return result.data.asset as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to get asset");
    }
  }


  async function AssetSearch(term, page, assetTypes, legalEntities, showOnlyActive, locations) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiAssetSearch({ variables: { organizationId, term, page, assetTypes, legalEntities, showOnlyActive, locations } }) as any;
      return result.data.assetSearch as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to remove asset contract template");
    }
  }



  async function RemoveAssetContractTemplate(assetId: string, templateId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiRemoveAssetContractTemplate({ variables: { organizationId, assetId, templateId } }) as any;
      return result.data.removeAssetContractTemplate as Boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to remove asset contract template");
    }
  }



  async function AddAssetType(name: string, description: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiAddAssetType({ variables: { organizationId, name, description } }) as any;
      return result.data.addAssetType as any;
    }
    catch (err) {
      toast.error("Api Error, Unable to add asset type");
    }
  }


  async function SetAssetAddressId(assetId: string, addressId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetAddressId({ variables: { organizationId, assetId, addressId } }) as any;
      return result.data.setAssetAddress as Boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset address");
    }
  }



  async function SetAssetActiveFlag(assetId: string, active: Boolean) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiSetAssetActiveFlag({ variables: { organizationId, assetId, active } }) as any;
      return result.data.setAssetActiveFlag as Boolean;
    }
    catch (err) {
      toast.error("Api Error, Unable to set asset active flag");
    }
  }





  return {
    SetAssetActiveFlag,
    SetAssetAddressId,
    AddAssetType,
    RemoveAssetContractTemplate,
    AssetSearch,
    GetAsset,
    GetLayouts,
    SetAssetDescription,
    SetAssetLocationId,
    SetAssetName,
    SetAssetTypeDescription,
    SetAssetTypeRequireVehicle,
    SetAssetTypeRegenerateContractsOnMove,
    SetAssetTypeRent,
    SetAssetTypeDeposit,
    SetAssetTypeOneTimePayment,
    SetAssetTypePublished,
    SetAssetTypeAvailableForLeasing,
    GetAssetType,
    SetAssetDetail,
    AddAssetContractTemplate,
    GetAssetContractTemplates,
    CreateAsset,
    AddLocation
  };
}




